<template>
  <my-modal>
      <div class="modal-container">
        <div class="modal-header">
          <h3>Seleccionar artículo</h3>
          <button type="button" class="close" @click="cerrarModal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <DataList url="/articulos" :fields="fields" :rowClick="selectArticulo" :modal="true" ref="datatable"></DataList>
        </div>
        <div class="modal-footer">
          <button class="btn btn-danger" @click="cerrarModal">Cerrar</button>
        </div>
      </div>
  </my-modal>
</template>
<script>
import DataList from "@/components/layouts/DataList";
import MyModal from "@/components/layouts/MyModal";
export default {
  name: "ModalSelectArticulo",
  components: {
    DataList,
    MyModal
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  data() {
    return {
      fields: [
        {
          name: "descripcion",
          label: "",
          type: "title",
          class: ""
        },
        {
          name: "stock",
          label: "Stock",
          type: "field",
          class: "text-focus",
        },
        {
          name: "precio_final",
          label: "Precio",
          type: "field",
          class: "text-success",
          prepend: "$"
        }
      ],
      loading: false
    };
  },
  methods: {
    selectArticulo(articulo) {
      this.$emit("selectArticulo", articulo);
    },
    cerrarModal() {
      this.$emit("cerrarModalArticulo");
    },
    clear(){
      this.$refs.datatable.clear();
    }
  }
};
</script>
